import { ModelUtility, RequestDataModel } from '@ktvs8/gocoo-engine-front-end';
import { ProgramTestData, getDay } from './Program-test-data';

export function filterReceiptDate(requestModel: RequestDataModel) {
  return ReceiptDateTestData;
}

export const ReceiptDateTestData = [
  {
    TicketType: 'ReceiptDate',
    TicketKey: getDay(-5) + '#1111-2222-3333',
    ReceiptDate: getDay(-5),
    MProgramTicketKey: 'test#1111-1111-1112',
    MProgramOrderTicketKey: '',
    ProgramName: '日本の米は世界一',
    OrderContent: 'Everybody eat　牛丼 Everybody eat　カツ丼',
    SupplierName: '打首獄門同好会',
    IsFreelance: false,
    OrderDate: getDay(0),
    PaymentDeadline: getDay(2),
    SapNumber: '',
    ProgramOrderTicketLink: getProgramOrderTicketKey(getDay(-5) + '#1111-2222-3333'),
    AlertStartDate: getDay(0),
    Status: 'Paid',
    StatusName: '支払済',
  },
  {
    TicketType: 'ReceiptDate',
    TicketKey: getDay(-6) + '#1111-2222-4444',
    ReceiptDate: getDay(-6),
    MProgramTicketKey: 'test#1111-1111-1112',
    MProgramOrderTicketKey: '',
    ProgramName: 'デリシャスティック',
    OrderContent: 'たこやき チーズ コーンポタージュ',
    SupplierName: '打首獄門同好会',
    IsFreelance: false,
    OrderDate: getDay(0),
    PaymentDeadline: getDay(2),
    SapNumber: '',
    ProgramOrderTicketLink: [],
    AlertStartDate: getDay(0),
    Status: 'Paid',
    StatusName: '支払済',
  },
  {
    TicketType: 'ReceiptDate',
    TicketKey: getDay(-8) + '#1111-2222-4444',
    ReceiptDate: getDay(-8),
    MProgramTicketKey: '',
    MProgramOrderTicketKey: '',
    ProgramName: '死亡フラグを立てないで',
    OrderContent: '立てないで死亡フラグ　それ言っちゃったらもうダメだから',
    SupplierName: '打首獄門同好会',
    IsFreelance: false,
    OrderDate: getDay(0),
    PaymentDeadline: getDay(2),
    SapNumber: '',
    ProgramOrderTicketLink: getProgramOrderTicketKey(getDay(-8) + '#1111-2222-4444'),
    AlertStartDate: getDay(0),
    Status: 'Paid',
    StatusName: '支払済',
  },
  {
    TicketType: 'ReceiptDate',
    TicketKey: getDay(-5) + '#1111-2222-3334',
    ReceiptDate: getDay(-5),
    MProgramTicketKey: '',
    MProgramOrderTicketKey: '',
    ProgramName: '青と夏',
    OrderContent: '夏が始まった 合図がした',
    SupplierName: 'Mrs. GREEN APPLE',
    IsFreelance: false,
    OrderDate: getDay(8),
    PaymentDeadline: getDay(2),
    SapNumber: '',
    ProgramOrderTicketLink: getProgramOrderTicketKey(getDay(-5) + '#1111-2222-3334'),
    AlertStartDate: getDay(0),
    Status: 'Paid',
    StatusName: '支払済',
  },
  {
    TicketType: 'ReceiptDate',
    TicketKey: getDay(-3) + '#1111-2222-1111',
    ReceiptDate: getDay(-3),
    MProgramTicketKey: '',
    MProgramOrderTicketKey: '',
    ProgramName: 'インフェルノ',
    OrderContent: '永遠は無いんだと　無いんだと云フ',
    SupplierName: 'Mrs. GREEN APPLE',
    IsFreelance: false,
    OrderDate: getDay(20),
    PaymentDeadline: getDay(2),
    SapNumber: '',
    ProgramOrderTicketLink: getProgramOrderTicketKey(getDay(-3) + '#1111-2222-1111'),
    AlertStartDate: getDay(0),
    Status: 'Paid',
    StatusName: '支払済',
  },
  {
    TicketType: 'ReceiptDate',
    TicketKey: getDay(-7) + '#1111-2222-3335',
    ReceiptDate: getDay(-7),
    MProgramTicketKey: '',
    MProgramOrderTicketKey: '',
    ProgramName: 'あつまれ！パーティーピーポー',
    OrderContent: '俺も混ぜてくれ　酒飲めへんし　踊れへんけど',
    SupplierName: 'ヤバイtシャツ屋さん',
    IsFreelance: true,
    OrderDate: getDay(13),
    PaymentDeadline: getDay(2),
    SapNumber: '1111-1111-1111',
    ProgramOrderTicketLink: [],
    AlertStartDate: getDay(0),
    Status: 'Unpaid',
    StatusName: '未支払',
  },
  {
    TicketType: 'ReceiptDate',
    TicketKey: getDay(-11) + '#1111-2222-3335',
    ReceiptDate: getDay(-11),
    MProgramTicketKey: '',
    MProgramOrderTicketKey: '',
    ProgramName: '案外わるないNHK',
    OrderContent: '案外わるないNHK！　(Hu・Hu～！)',
    SupplierName: 'ヤバイtシャツ屋さん',
    IsFreelance: true,
    OrderDate: getDay(13),
    PaymentDeadline: getDay(2),
    SapNumber: '1111-1111-1112',
    ProgramOrderTicketLink: getProgramOrderTicketKey(getDay(-11) + '#1111-2222-3335'),
    AlertStartDate: getDay(1),
    Status: 'Paid',
    StatusName: '支払済',
  },
];

/**
 * 自身に紐づくProgramOrderTicketKeyを取得する
 * @param receiptDateTicketKey
 * @returns
 */
export function getProgramOrderTicketKey(receiptDateTicketKey: string): string[] {
  let programOrderTicketKeyList: string[] = [];
  ProgramTestData.forEach((item) => {
    if (item.Subtickets === null || item.Subtickets === undefined || item.Subtickets instanceof Array === false) {
      return;
    }
    ModelUtility.getValueInObjectAsArray(item, 'Subtickets').filter((subItem) => {
      ModelUtility.getValueInObjectAsArray(subItem, 'ReceiptDateTicketLink').forEach((linkItem) => {
        if (linkItem === receiptDateTicketKey) {
          programOrderTicketKeyList.push(subItem.TicketKey);
        }
      });
    });
  });

  return programOrderTicketKeyList;
}
